import { render, staticRenderFns } from "./CustomMortgageEditor.vue?vue&type=template&id=1d5e5639"
import script from "./CustomMortgageEditor.vue?vue&type=script&lang=ts"
export * from "./CustomMortgageEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports